import React from 'react';
import { INTELLIMIZE_PRICESECTION_EVENT } from '../../../constants/defaults';
import _ from 'lodash';

const PriceCard = ({
  item,
  globalIndex,
  isFocused,
  loading,
  onKeyDown,
  isPreview = false
}) => {
  const onDrugClick = () => {
    _.sendIntellimizeEvent(INTELLIMIZE_PRICESECTION_EVENT.DRUG_CLICK);
  };

  const formatCurrency = (value, showDigits) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 599;
    const num =
      typeof value === 'string'
        ? Number(value.replace(/[^\d.-]/g, ''))
        : Number(value);
    if (!isFinite(num)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: isMobile ? 0 : showDigits ? 2 : 0
    }).format(num);
  };

  const canShowDigits = item => {
    const hasShortPrice =
      item.loyaltyPrice &&
      parseInt(item.loyaltyPrice, 10).toString().length < 3;

    const hasShortRetail =
      item.displayPrice &&
      parseInt(item.displayPrice, 10).toString().length < 3;

    return hasShortPrice || hasShortRetail;
  };

  const renderScript = (script = '') => {
    if (!script) return null;
    const MAX_MOBILE_CHARS = 35;
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 599;

    const text =
      isMobile && script.length > MAX_MOBILE_CHARS
        ? script.slice(0, MAX_MOBILE_CHARS).trim() + '...'
        : script;

    return <p className="price-card__subtitle">{text}</p>;
  };

  const renderPrice = item => {
    const showDigits = canShowDigits(item);

    return item.loyaltyPrice ? (
      <>
        <span className="price-card__price">
          {formatCurrency(item.loyaltyPrice, showDigits)}
        </span>
        {item.loyaltyPrice && (
          <span className="price-card__retail">
            {formatCurrency(item.displayPrice, false)}
          </span>
        )}
      </>
    ) : (
      <span className="price-card__price">
        {item.displayPrice
          ? formatCurrency(item.displayPrice, showDigits)
          : '—'}
      </span>
    );
  };

  return (
    <li
      className={`price-card ${isPreview ? 'price-card--preview' : ''}`}
      data-index={globalIndex}
      tabIndex={isPreview ? -1 : isFocused ? 0 : -1}
      onKeyDown={onKeyDown}
      onClick={onDrugClick}
      aria-label={`${item.displayName}`}
    >
      <a href={item.drugLink} className="price-card__link">
        <div className="price-card__inner">
          <h3 className="price-card__drug">{item.displayName}</h3>
          {renderScript(item.displayScript)}
          <div className="price-card__priceBlock">
            <span className="price-card__label">As low as</span>
            <div className="price-card__amounts">
              {loading ? (
                <span className="price-card__loading" aria-hidden="true">
                  <span className="skeleton skeleton-price" />
                </span>
              ) : (
                renderPrice(item)
              )}
            </div>
          </div>
        </div>
      </a>
    </li>
  );
};

export default PriceCard;
